import axios, { AxiosInstance } from 'axios'
import Cookies from 'universal-cookie/es6'

import { STORAGEKEYS } from '../../common/keys'
import { affiliatePartnersNames } from '../../pages/AffiliatePage/affiliatePartnersData'
import { SessionStorage } from '../../common/cookie-storage'
import { Environment } from '../../environment/app-settings'


//#region FinperialService Instance
let finperialInstance: FinperialService
//#endregion

class FinperialService {
   private readonly _finperialCallbackBaseApiUrl = 'https://finperial.pl';
   private readonly _PRD_finperialAffiliateUrlPath = "/aff_lsr";

   constructor() {
    if (finperialInstance) { //SINGLETON DESIGN PATTERN
       throw new Error("New instance cannot be created!!");
    }
 
    finperialInstance = this;
   }
   
   /**
    * Metoda pomocnicza zwracająca gotowy link do postbacka, wraz z odpowiednimi parametrami zapytania (query params)
   */
   private _preparePostbackLink (): string | undefined  {
      const currentAppUrl = window.location.origin
      
      const cookie = new Cookies();
      const currentAffiliateCookie = cookie.get(STORAGEKEYS.FORM_AFFILIATE_DATA_COOKIE)
      const sessionStorage = new SessionStorage()

      if(Boolean(currentAffiliateCookie)){
         if(currentAffiliateCookie.partnerId === affiliatePartnersNames.Finperial){   
            if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL)){ // LINK AFILIACYJNY DLA PRODUKCJI
               const alphaId = sessionStorage.get(STORAGEKEYS.SET_ALPHA_ID) //!! IMPORTANT - METODA TA MUSI ZOSTAĆ WYWOŁANA NA ETAPIE GDZIE NUMER WNIOSKU JEST ZNANY
   
               const finperialCallbackQueryParams = new URLSearchParams({
                  offer_id: "22", // WARTOŚĆ STAŁA
                  adv_sub: alphaId,
                  transaction_id: currentAffiliateCookie.urlParams.click_id,
               })
         
               return `${this._finperialCallbackBaseApiUrl + this._PRD_finperialAffiliateUrlPath}?${finperialCallbackQueryParams.toString()}`
            }
         }
      }
 
      return undefined
   }

   //!! IMPORTANT - Póki co POSTBACK dla FINPERIAL nie jest używany, możliwe przywrócenie w przyszłości.
   /**
    * Funkcja obsługująca mechanizm POSTBACK partnera Finperial dla LEAD'A
   */
   // public async sendLeadPostback(): Promise<void> {
   //    const currentAppUrl = window.location.origin
   //    const finperialCallbackUrl = this._preparePostbackLink()

   //    if(currentAppUrl.includes(Environment.OPENA_FORM_PRD_URL) && finperialCallbackUrl !== undefined){ // POSTBACK wykonujemy TYLKO NA PRODUKCJI
   //       await fetch(finperialCallbackUrl, { mode: 'no-cors', method: "GET" }).catch(e => console.error("Nie udało się wykonać zapytania Postback dla partnera Finperial."))   
   //    }

   //    return
   // }
}
 
let finperialService = Object.freeze(new FinperialService())//SINGLETON DESIGN PATTERN
export default finperialService;